import React, { Component } from 'react'
import { translate } from "react-i18next"
import Geosuggest from 'react-geosuggest'
import './googleMapsAddress.css'

class InputGoogleMapsAddress extends Component {
  constructor(props){
    super(props)

    const [address, aptUnit, zipCode] = this.valuesFromProps(props)

    this.state = {
      address,
      aptUnit,
      zipCode,
      error: false
    }

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validate = this.validate.bind(this)
    this.handleAptUnitChange = this.handleAptUnitChange.bind(this)
    this.handleZipCodeChange = this.handleZipCodeChange.bind(this)
  }

  valuesFromProps(props) {
    if (props.value === null || props.value === undefined) {
      return ['', '', '']
    }

    if (props.value.indexOf('Apt/Unit') > -1 && props.value.indexOf('Zip Code') > -1) {
      return props.value.split(/Apt\/Unit|Zip Code/g).map(s => s.trim())
    } else if (props.value.indexOf('Apt/Unit') > -1) {
      return [...props.value.split(/Apt\/Unit/g).map(s => s.trim()), '']
    } else if (props.value.indexOf('Zip Code') > -1) {
      const values = props.value.split(/Zip Code/g).map(s => s.trim())
      return [values[0], '', values[1]]
    } else {
      return [props.value, '', '']
    }
  }

  componentWillReceiveProps(nextProps){
    const [address, aptUnit] = this.valuesFromProps(nextProps)

    this.setState({ address, aptUnit })

    if(document.hasFocus()) {
      this._geoSuggest.focus()
    }
  }
  componentDidMount(){
    if(document.hasFocus()) {
      this._geoSuggest.focus()
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if(document.hasFocus()) {
      //this._geoSuggest.focus()
    }
  }

  handleSubmit(){
    if(this.props.onSubmit && this.validate()){
      let value = this.state.address.trim()
      if (this.state.aptUnit.trim()) value += ` Apt/Unit ${this.state.aptUnit.trim()}`
      if (this.state.zipCode.trim()) value += ` Zip Code ${this.state.zipCode.trim()}`

      this.props.onSubmit(value)
    } else {
      this.setState({ error: true })
      setTimeout(() => { this.setState({ error: false }) }, 500)
    }
  }

  validate(){
    const { address } = this.state
    const { required } = this.props

    if( address.length === 0 ) {
      return !required
    }

    return true
  }

  handleInputChange(value){
    if (value && value.description) {
      this.setState({ address: value.description })
      this.unitInput.focus()
    }
  }

  handleKeyDown(e){
    if( e.keyCode === 13 ) { // Enter
      e.preventDefault()
      this.handleSubmit()
    }
  }

  handleAptUnitChange(e) {
    this.setState({
      aptUnit: e.target.value,
    })
  }

  handleZipCodeChange(e) {
    this.setState({
      zipCode: e.target.value,
    })
  }

  render() {
    let { color, t } = this.props

    return (
      <div className="booking-input booking-input-google-maps-address inside-button">
        <div className={`booking-input-wrapper ${ this.state.error ? 'shake' : '' }`}>
          <Geosuggest
            onSuggestSelect={this.handleInputChange}
            ref={el=>this._geoSuggest=el}
            initialValue={this.state.address}
            types={['address']}
            placeholder={t('street-address')}
          />
          <input ref={el=>this.unitInput=el} type="text" id="map-address-unit" placeholder={t('apt-unit')} onChange={this.handleAptUnitChange} value={this.state.aptUnit} onKeyDown={this.handleKeyDown} />
          <input ref={el=>this.zipInput=el} type="text" id="map-zip-code" placeholder={t('zip-code')} onChange={this.handleZipCodeChange} value={this.state.zipCode} onKeyDown={this.handleKeyDown} />
          <button onClick={this.handleSubmit} style={{ backgroundColor: color }}>{this.props.okButtonLabel}</button>
        </div>
      </div>
    );
  }
}

export default translate("translations")(InputGoogleMapsAddress)
